import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getLaboratories = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/laboratories', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getLaboratoriesAll = () => {
  return api.http.get(`/laboratories/select_search`)
}

export const getLaboratory = id => {
  return api.http.get(`/laboratories/${id}`)
}

export const searchLaboratories = term => {
  return api.http.get('/laboratories/select_search', {
    params: {
      term
    }
  })
}

export const getSelectLaboratories = (term, callback) => {
  searchLaboratories(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteLaboratory = id => {
  return api.http.delete(`/laboratories/${id}`)
}

export const restoreLaboratory = id => {
  return api.http.put(`/laboratories/${id}/restore`)
}

export const editLaboratory = laboratory => {
  return api.http.put(`/laboratories/${laboratory._id}`, laboratory)
}

export const addLaboratory = laboratory => {
  return api.http.post('/laboratories', laboratory)
}



// WEBPACK FOOTER //
// ./src/api/laboratories.js